import React from 'react';
import { Form } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../hoc/Localization';
import { RouteContext } from '../../../hoc/Route';
import Button from '../../Button';
import Input from '../../Input';
import api from '../../../utils/api';
import { getCookie } from '../../../utils/cookies';
import styles from './styles.less';

const FormItem = Form.Item;

const SubscribeWrapper = ({ categories, onSubmit, pageSuffix }) => {
  const { t } = React.useContext(LocalizationContext);
  const { page } = React.useContext(RouteContext);
  const isBlog =
    page === 'blog' || page === 'blogSubCategory' || page === 'blogCategory' || page === 'article';

  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState(null);
  const [form] = Form.useForm();

  const statusesMap = {
    success: {
      icon: <ExclamationCircleOutlined />,
      text: t('frontpage.newsletter.form.success'),
    },
    missingEmail: (
      <div className={styles.validation}>
        <ExclamationCircleOutlined />
        {t('frontpage.newsletter.form.validation.requiredEmail')}
      </div>
    ),
    invalidEmail: (
      <div className={styles.validation}>
        <ExclamationCircleOutlined />
        {t('frontpage.newsletter.form.validation.invalidEmail')}
      </div>
    ),
    existingEmail: {
      text: t('frontpage.newsletter.form.validation.duplicate'),
    },
  };

  const handleSubmit = async values => {
    setStatus({ status: null });
    setLoading(true);

    const response = await api
      .post('user-subscriptions', {
        email: values.user.email,
        categories: categories || ['front page subscription'],
        page: `${page}${pageSuffix}`,
        userTrackingId: getCookie('sync'),
      })
      .catch(() => null);

    form.resetFields();
    if (response) {
      setStatus(response.type || response.status);
    }
    setLoading(false);

    onSubmit();
    setTimeout(() => setStatus({ status: null }), 15000);
    return true;
  };

  return (
    <div className={`${styles.container} ${isBlog && styles.blogTheme}`}>
      {!isBlog && <p className="h1">{t('frontpage.newsletter.heading')}</p>}
      <Form form={form} onFinish={handleSubmit}>
        <FormItem
          style={{
            marginBottom: 0,
          }}
          name={['user', 'email']}
          rules={[
            { type: 'email', message: statusesMap.invalidEmail },
            { required: true, message: statusesMap.missingEmail },
          ]}
        >
          <div className={styles.inputs}>
            <Input
              version="long"
              autoComplete="off"
              placeholder={t('frontpage.newsletter.form.email')}
              onInput={() => setStatus(null)}
              size="large"
            />
            <div className={styles.right}>
              <Button version="large" type="secondary" htmlType="submit" loading={loading}>
                {t('frontpage.newsletter.form.submit')}
              </Button>
              {!isBlog && (
                <div>
                  <img
                    className={styles.plus1}
                    src="/static/images/frontpage/plus.png"
                    alt="plus"
                  />
                  <img
                    className={styles.plus2}
                    src="/static/images/frontpage/plus.png"
                    alt="plus"
                  />
                </div>
              )}
            </div>
          </div>
        </FormItem>
        {(!!status || isBlog) && (
          <div id="subscribeStatus" className={styles.status}>
            {statusesMap[status] && statusesMap[status].icon}
            {statusesMap[status] && statusesMap[status].text}
          </div>
        )}
      </Form>
    </div>
  );
};

SubscribeWrapper.propTypes = {
  categories: PropTypes.array,
  onSubmit: PropTypes.func,
  pageSuffix: PropTypes.string,
};
SubscribeWrapper.defaultProps = {
  categories: [],
  onSubmit: () => { },
  pageSuffix: '',
};
const Subscribe = SubscribeWrapper;

export default Subscribe;
